import React from "react";
import "./footer.scss";

declare const window: any;
const Footer = () => {
  function createMarkup() {
    return {
      __html: `<a id="tnt_adchoices" consent="undefined" style="display: inline;">
                    <script type="text/javascript" src="//consent.truste.com/notice?domain=turner.com&amp;c=tnt_adchoices&amp;text=true&amp;country=us" id="truste_0.6542881106300678"></script><script async="async" type="text/javascript" crossorigin="" src="https://consent.trustarc.com/asset/notice.js/v/v1.7-14"></script>
                <a id="icon-id04357124889672225" tabindex="0" role="link" style="cursor: pointer;" lang="en"></a></a>`
    };
  }

  const doNotSellTitle = window.WM
    ? window.WM.UserConsent.getLinkTitle()
    : "Do Not Sell My Information";

  const linkAction = window.WM
    ? window.WM.UserConsent.getLinkAction()
    : () => null;

  const handleDoNotSellClick = (e: Event) => {
    e.preventDefault();
    linkAction();
  };

  return (
    <footer id="am-dad-footer">
      <div className="footer-inner">
        <div className="tbs-links">
          <a
            href="https://www.tbs.com/shows/american-dad/watch-now"
            target="_blank"
          >
            <div className="footer-button">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                <path d="M256 0C114.8 0 0 114.8 0 256s114.8 256 256 256 256-114.8 256-256S397.2 0 256 0zm0 490.7C126.6 490.7 21.3 385.4 21.3 256S126.6 21.3 256 21.3 490.7 126.6 490.7 256 385.4 490.7 256 490.7z" />
                <path d="M357.8 247l-149.3-96c-3.3-2.1-7.5-2.2-10.9-.4-3.4 1.9-5.6 5.5-5.6 9.4v192c0 3.9 2.1 7.5 5.6 9.4 1.6.9 3.4 1.3 5.1 1.3 2 0 4-.6 5.8-1.7l149.3-96c3-2 4.9-5.3 4.9-9s-1.9-7-4.9-9z" />
              </svg>
              <p>Watch Episodes</p>
            </div>
          </a>
          <a href="https://www.tbs.com">
            <div className="footer-button">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                <path d="M256 0C114.8 0 0 114.8 0 256s114.8 256 256 256 256-114.8 256-256S397.2 0 256 0zm0 490.7C126.6 490.7 21.3 385.4 21.3 256S126.6 21.3 256 21.3 490.7 126.6 490.7 256 385.4 490.7 256 490.7z" />
                <path d="M401.9 234.9H186.1l74-73.6c8.3-8.2 8.3-21.6.1-29.8-8.2-8.3-21.6-8.3-29.8-.1L120.2 241.1c-8.2 8.2-8.3 21.6 0 29.9l110.2 109.7c8.3 8.2 21.6 8.2 29.8-.1 8.2-8.3 8.2-21.6-.1-29.8l-74-73.6h215.8c11.6 0 21.1-9.4 21.1-21.1 0-11.7-9.4-21.2-21.1-21.2z" />
              </svg>
              <p>Back to TBS.com</p>
            </div>
          </a>
        </div>
        <div className="divider"></div>
        <div className="legal-links">
          <a href="https://www.tbs.com/terms" target="_blank">
            Terms of Use
          </a>
          <a href="https://www.tbs.com/privacy" target="_blank">
            Privacy Policy
          </a>
          <a onClick={(e: any) => handleDoNotSellClick(e)} href="">
            {doNotSellTitle}
          </a>
          <span dangerouslySetInnerHTML={createMarkup()} />
        </div>
      </div>
    </footer>
  );
};
export default Footer;
